
import { AxiosResponse } from 'axios'
import { localConfig } from '../../../Configs/localConfig'
import { tryError } from '../../Afins'
import { api } from '../../api'

export interface TypesTipoEquipeLiderGerenciar {
  itens: ItensTipoEquipeLiderGerenciarTypes[]
}

export interface ItensTipoEquipeLiderGerenciarTypes {
  cod_func: number
  cod_conta: number
  cod_cliente: number
  status: number
  acessa_sistema: number
  cod_perfil_conta: number
  cod_perfil_cliente: number
  cod_perfil_cliente_geral: number
  cod: number
  cod_consultor: number
  acesso_cliente: number
  usuario_nome: string
  conta_nome: string
  cliente_nome: string
  email: string
  cliente_logo: string
  usuario_tipo: number
}

type TypesQuery = {
  cod?: number
  codConsultor?: number
  codLider?: number
  embed?: string
}

const url = '/gerenciar-equipe-lider'

export const getTipoEquipeLiderGerenciar = async (params: TypesQuery) => {
  try {
    const { conta, codCliente } = localConfig()
    const resp: AxiosResponse<TypesTipoEquipeLiderGerenciar> = await api.get(url, {
      params: {
        codConta: conta,
        codCliente,
        ...params,
        pagination: -1,
      },
    })

    return resp
  } catch (error) {
    tryError(error)
  }
}

export const postTipoEquipeLiderGerenciar = async (data) => {
  try {
    const { codCliente, conta } = localConfig()
    const resp: AxiosResponse<TypesTipoEquipeLiderGerenciar> = await api.post(url, data, {
      params: {
        codCliente,
        codConta: conta,
      },
    })

    return resp
  } catch (error) {
    tryError(error)
  }
}

export const delTipoEquipeLiderGerenciar = async (codLider, codTecnico) => {
  try {
    const { codCliente, conta } = localConfig()
    const resp: AxiosResponse<TypesTipoEquipeLiderGerenciar> = await api.delete(
      `${url}/consultor/${codLider}/usuario/${codTecnico}`,
      {
        params: {
          codConta: conta,
          codCliente,
        },
      }
    )
    return resp
  } catch (error) {
    tryError(error)
  }
}
